import React from "react"
import Text from "../Atoms/Text"

interface ButtonTextProps {
    children: React.ReactNode
    size: "big" | "small"
    icon?: React.ReactNode // Optional icon element
    iconPosition?: "left" | "right" // Optional icon position
    className?: string
    [key: string]: any
    asChild?: boolean
    asElement?: React.ElementType
}

const ButtonText: React.FC<ButtonTextProps> = ({
    children,
    size,
    icon,
    iconPosition = "left",
    asElement,
    asChild = false,
    ...props
}) => {
    const sizeClasses = size === "big" ? "gap-[8px]" : "gap-[4px]"
    const baseClasses = `
    !uppercase
    focus:outline-none
    inline-flex
    items-center
    justify-center 
    ${sizeClasses} 
    text-main-black
    hover:text-main-dark-grey
    hover:cursor-pointer
    disabled:text-main-dark-grey
    disabled:cursor-not-allowed
    ${asChild ? props : ""}
  `

    const Element = asElement || "button"

    return (
        <Text
            asChild={asChild}
            weight="regular"
            size={size === "big" ? "medium" : "small"}
        >
            <Element className={baseClasses} {...props}>
                {iconPosition === "left" && icon}
                {children}
                {iconPosition === "right" && icon}
            </Element>
        </Text>
    )
}

export default ButtonText
